import contrast from '@js/misc/contrast';
import legacy from '@js/dom/legacy';

const ID = 'credere-tokens';

const PRIMARY = '--cordel-color-brand-primary';
const CONTRAST = '--cordel-color-brand-contrast';

function brand() {
  const root = document.querySelector(':root');
  const contrasted = contrast(window.getComputedStyle(root).getPropertyValue(PRIMARY))
    ? 'var(--cordel-color-constant-dark)'
    : 'var(--cordel-color-constant-light)';

  root.style.setProperty(CONTRAST, contrasted);
}

// The host's CSS on its way into the page: `<` goes, `:root` becomes the widget's scope, and
// every renamed name is rewritten to the one the markup carries today.
export function sanitize(string) {
  return legacy(string.replace(/</g, '')).replace(/:root/g, '.product--embed');
}

export function stylize(string = '') {
  const existing = document.getElementById(ID);
  const tag = existing || document.createElement('style');

  tag.textContent = sanitize(string);

  if (!existing) {
    tag.id = ID;
    document.body.append(tag);
  }

  brand();
}
